<template>
	<div class="popup">
    <div class="popup-header">
      <h2 class="modal-title">{{ workfield_by_id(resource.workfield_id).name }} @ {{ project_by_id(resource.project_id).title }}</h2>
    </div>
    <div class="popup-body" >
      <b-container>
        <b-table :items="items">
          <template #cell(id)="row">
            {{username_by_id(row.item.id)}}
            <div class="btn" @click="$emit('close',{id:row.item.id,resource_id:resource.id})">
                <font-awesome-icon icon="check" /> select
            </div>
        </template>
        <template #cell(workfield)="row">
          <font-awesome-icon v-if="row.item.workfield==1" icon="check"  style="color: green;" />
          <font-awesome-icon v-else icon="times" style="color: red;" />
        </template> 
        <template #cell(distance)="row">
          {{ row.item.distance.toFixed(2) }}
        </template>                

        <template #cell(isplanned)="row">
          <font-awesome-icon v-if="row.item.isplanned.length!=0" icon="check"  style="color: green;" />
          <font-awesome-icon v-else icon="times" style="color: red;" />
        </template>        
      </b-table>
      </b-container>
    </div>
    <div class="popup-footer">
            <div class="btn btn-primary" @click="$emit('close')">{{ $t("buttons.cancel") }}</div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'planning-people-modal',
  data() {
    return {
      reason: null,
      reasonkey: "reasonkey",
      wasabsent:false,
      freeweeknumber:0,
      freeyearnumber:0,
    }
  },
  props: {
    items: Array,
    resource:Object
  },
  computed: {

    ...mapState([
      'invoiceextra',
      'current_user',

    ]),
    ...mapGetters([
    'append_data_string',

    ])
  },

  methods: {

    close_modal() {
      this.$bvModal.hide('BSPlanningPeopleID')
    },
  },

}    
</script>
